import { BrandsService, configureApiClient } from '../api/client';
import { Order } from '../my-type';
import { hasRole } from '../util/roles';
import { authUserData } from '.';
import { getOrdersByTeamCode } from './OrderService';

export type FleetCalendarOrder = Order & { fleetAmount: number | null };

// Keep passenger pricing intact; only the fleet calendar uses this amount.
export async function getFleetCalendarOrders(teamCode: string, yearMonth: string): Promise<FleetCalendarOrder[]> {
  const orders = await getOrdersByTeamCode(teamCode, yearMonth);
  if (orders === null) throw new Error('Orders unavailable');
  const user = authUserData();
  const canViewAmounts = hasRole(user?.roleString, 'Lead') || hasRole(user?.roleString, 'Admin');
  const hasBrandOrders = orders.some(order => order.brandId != null);
  configureApiClient({ tokenProvider: () => user?.jwtToken ?? null });
  const dispatches = hasBrandOrders && canViewAmounts ? await BrandsService.getApiBrandsTeamOrders() : [];
  const amounts = new Map(dispatches.map(row => [row.order?.orderId, row.teamAmount]));
  return orders.map(order => ({
    ...order,
    fleetAmount: order.brandId != null
      ? amounts.get(order.orderID) ?? null
      : order.rideFee,
  }));
}
